export default {
    "ADMIN": "ADMIN",
    "CONSULTANT": "CONSULTANT"
};